import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  additionalItemsBannerHeader: {
    defaultMessage: 'You have additional items in your shipment',
    description:
      'Header for a banner that informs the user that the shipment contains additional items not included in the original order.',
    id: 'hqdwzs',
  },
  additionalItemsBannerContent: {
    defaultMessage:
      'This shipment contains additional items not included in the original order. These items will not be reflected in any updates made to the marketplace.',
    description:
      'Content for a banner that informs the user that the shipment contains additional items not included in the original order.',
    id: 'WWJQXq',
  },
  dontShowThisAgain: {
    defaultMessage: "Don't show this again",
    description: 'Text for a button that dismisses a banner and prevents it from appearing in the future.',
    id: 'KlkWF/',
  },
});
